import { cssPrefix } from '../../../../const/Constant';
import { Icon } from './Icon';
import { Item } from './base/Item';

class Merge extends Item {
  constructor() {
    super(`${cssPrefix}-tools-merge`);
    this.icon = new Icon('merge');
    this.childrenNodes(this.icon);
    this.setTitleTips('合并单元格');
  }
}

export { Merge };
